
  /**
    * options:
    *		style: 'number','currency','percentage'
    *		negativeFormat: 'accounting' or 'standard'
    *		grouping (thousands separator): true or false
    * 	precision - decimal places - defaults to '0'
    */

/** use the prefix to prevent collisions **/
Number.prototype.wdFormat = function({ style = 'number', negative = 'standard', grouping = true, precision = 0 } = {}) {
    const cfg = { 
        useGrouping: grouping
    };

    // Handle precision correctly
    if (typeof precision === 'number' && precision > 0) {
        cfg.maximumFractionDigits = precision;
        cfg.minimumFractionDigits = precision;
    }

    // Handle different styles
    if (style === 'currency') 
    {
        cfg.style = 'currency';
        cfg.currency = 'USD'; // You can make this dynamic if needed
        
        if (negative == 'accounting') cfg.currencySign = 'accounting';
    } 
    else if ( style === 'percent')
    {
      cfg.style = 'percent';
    }
    else 
    {
      cfg.style = 'decimal'; // Ensure it's explicitly a number format
    }

    let retVal = new Intl.NumberFormat('en-US', cfg).format(this);

    //NumberFormat has a percent style, but it multiples by 100 which I 
    //usually have already done at this point so I made 'percentage' an option
    if (style == 'percentage')
    {
      if (negative == 'accounting') retVal = retVal.replace(')','%)');
      else retVal += '%';
    }
    
    return retVal;

};

Number.prototype.formatDecimals = function(decimals)
{
	return this.toFixed(decimals);
}

Number.prototype.formatGroups = function(decimals)
{
	return this.format({decimals:decimals,group:','});
}

Number.prototype.formatPercent = function(decimals,negMode)
{
	return String(this).formatPercent(decimals,negMode);
}

Number.prototype.formatCurrency = function(decimals,negMode)
{
	return String(this).formatCurrency(decimals,negMode);
}

Number.prototype.formatSeconds = function(showSeconds)
{
	return String(this).formatSeconds(showSeconds);
}

Number.prototype.formatSize = function()
{
  const bytes = parseInt(this);

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

  if (bytes === 0)
  {
    return '0 Bytes';
  }
  else if (i === 0) 
  {
    return bytes + ' ' + sizes[i];
  }

  return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
};

Number.prototype.formatBoolean = function()
{
	return (this == true || this == '1') ? 'Yes' : 'No';
};

